import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { productList } from '../../../mocks/products';

export default function ProductsSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-[#FFF8FB] py-24 relative overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-30 pointer-events-none" />
      <div className="max-w-[1400px] mx-auto px-6 relative z-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <div className="inline-flex items-center gap-2 mb-5 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full">
              <i className="ri-layout-grid-line text-primary text-sm" />
              <span className="text-primary text-xs font-medium uppercase tracking-wider">{t('products.tag')}</span>
            </div>
            <h2 className="text-4xl xl:text-5xl font-heading font-bold text-gray-900 mb-3">{t('products.title')}</h2>
            <p className="text-gray-500 text-base">{t('products.subtitle')}</p>
          </div>
          <Link to="/products" className="inline-flex items-center gap-2 text-primary text-sm font-medium hover:gap-3 transition-all duration-200 whitespace-nowrap cursor-pointer">
            查看全部产品 <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {productList.map((product) => (
            <Link key={product.id} to={product.path} className="group bg-white border border-primary-100 rounded-2xl overflow-hidden card-glow transition-all duration-300 hover:-translate-y-2 cursor-pointer">
              <div className="relative w-full h-52 overflow-hidden">
                <img src={product.image} alt={t(product.titleKey)} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-white via-white/10 to-transparent" />
                <div className="absolute top-0 left-0 right-0 h-0.5" style={{ background: `linear-gradient(to right, transparent, ${product.color}, transparent)` }} />
                <div className="absolute bottom-4 left-4 w-9 h-9 flex items-center justify-center rounded-lg" style={{ backgroundColor: `${product.color}25`, border: `1px solid ${product.color}40` }}>
                  <i className={`${product.icon} text-base`} style={{ color: product.color }} />
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-bold text-gray-900 mb-3">{t(product.titleKey)}</h3>
                <ul className="space-y-1.5 mb-4">
                  {product.features.map((feat, fi) => (
                    <li key={fi} className="flex items-start gap-2 text-xs text-gray-500">
                      <span className="w-1 h-1 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: product.color }} />
                      {feat}
                    </li>
                  ))}
                </ul>
                <div className="flex items-center gap-1 text-xs font-medium" style={{ color: product.color }}>
                  {t('products.more')} <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="mt-12 flex items-center justify-center">
          <div className="flex flex-wrap items-center gap-3 bg-white border border-primary-200 rounded-2xl px-8 py-5">
            <i className="ri-information-line text-primary text-lg" />
            <span className="text-gray-600 text-sm">私募类、分红类、社交类、游戏类等更多 DApp 解决方案，请咨询我们的商务团队</span>
            <Link to="/contact" className="px-4 py-2 bg-primary/10 border border-primary/30 text-primary text-sm font-medium rounded-full hover:bg-primary hover:text-white transition-all duration-200 whitespace-nowrap cursor-pointer">
              立即咨询
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
